(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ef"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ef"] = parcelRequire;
}

var $E0sjW = parcelRequire("E0sjW");
let $1e36063d22283059$var$STOPSLIDERS = false;
const $1e36063d22283059$var$ALTHEIM = [
    "url('https://weinhandel-weber.de/assets/standorte-slider/Am01.jpg')",
    "url('https://weinhandel-weber.de/assets/standorte-slider/Am02.jpg')",
    "url('https://weinhandel-weber.de/assets/standorte-slider/Am03.jpg')",
    "url('https://weinhandel-weber.de/assets/standorte-slider/Am04.jpg')",
    "url('https://weinhandel-weber.de/assets/standorte-slider/Am05.jpg')",
    "url('https://weinhandel-weber.de/assets/standorte-slider/Am06.jpg')",
    "url('https://weinhandel-weber.de/assets/standorte-slider/Am07.jpg')"
];
const $1e36063d22283059$var$startSlider = (wrapper, auto = true)=>{
    let isAnimating = false;
    let running = auto;
    const slider = wrapper.querySelector(".standorte__img-slider");
    const IMAGES = $1e36063d22283059$var$ALTHEIM;
    window.addEventListener("focus", ()=>{
        running = auto;
    });
    window.addEventListener("blur", ()=>{
        running = false;
    });
    wrapper.addEventListener("mouseleave", ()=>{
        running = auto;
        startInterval();
    });
    wrapper.addEventListener("mouseenter", ()=>{
        running = false;
    });
    let interval;
    const startInterval = ()=>{
        if (interval) clearInterval(interval);
        interval = setInterval(()=>{
            if (running && !$1e36063d22283059$var$STOPSLIDERS) next(0.75);
        }, 3500);
    };
    startInterval();
    let currentPos = 0;
    const next = (duration = 0.25)=>{
        if (isAnimating) return;
        isAnimating = true;
        const currentImages = Array.from(wrapper.querySelectorAll(".standorte__img"));
        const currentImage = currentImages.find((el)=>el.dataset.pos === currentPos.toString());
        const newImage = document.createElement("div");
        newImage.classList.add("standorte__img");
        let nextPos = currentPos + 1;
        if (nextPos >= IMAGES.length) nextPos = 0;
        const bgImage = IMAGES[nextPos];
        newImage.style.backgroundImage = bgImage;
        newImage.dataset.pos = nextPos.toString();
        currentPos = nextPos;
        slider.appendChild(newImage);
        (0, $E0sjW.gsap).set(newImage, {
            x: "+100%"
        });
        (0, $E0sjW.gsap).to(newImage, {
            duration: duration,
            x: "0%"
        });
        (0, $E0sjW.gsap).to(currentImage, {
            duration: duration,
            x: "-100%",
            onComplete: ()=>{
                slider.removeChild(currentImage);
                isAnimating = false;
            }
        });
    };
    const prev = (duration = 0.25)=>{
        if (isAnimating) return;
        isAnimating = true;
        const currentImages = Array.from(wrapper.querySelectorAll(".standorte__img"));
        const currentImage = currentImages.find((el)=>el.dataset.pos === currentPos.toString());
        const newImage = document.createElement("div");
        newImage.classList.add("standorte__img");
        let nextPos = currentPos - 1;
        if (nextPos < 0) nextPos = IMAGES.length - 1;
        const bgImage = IMAGES[nextPos];
        newImage.style.backgroundImage = bgImage;
        newImage.dataset.pos = nextPos.toString();
        currentPos = nextPos;
        slider.appendChild(newImage);
        (0, $E0sjW.gsap).set(newImage, {
            x: "-100%"
        });
        (0, $E0sjW.gsap).to(newImage, {
            duration: duration,
            x: "0%"
        });
        (0, $E0sjW.gsap).to(currentImage, {
            duration: duration,
            x: "+100%",
            onComplete: ()=>{
                slider.removeChild(currentImage);
                isAnimating = false;
            }
        });
    };
    const stop = ()=>{
        if (!running) return;
        running = false;
    };
    const arrowRight = wrapper.querySelector(".arrow--right");
    const arrowLeft = wrapper.querySelector(".arrow--left");
    arrowRight.addEventListener("click", (e)=>{
        stop();
        next();
    });
    arrowLeft.addEventListener("click", (e)=>{
        stop();
        prev();
    });
};
const $1e36063d22283059$var$wrappers = Array.from(document.querySelectorAll(".standorte__img-wrapper"));
$1e36063d22283059$var$wrappers.forEach((wrapper)=>{
    if (!wrapper.classList.contains("standorte__img-wrapper--overlay")) {
        $1e36063d22283059$var$startSlider(wrapper);
        wrapper.addEventListener("click", (e)=>{
            if (!e.target.classList.contains("fas")) $1e36063d22283059$var$openModal(wrapper);
        });
    }
});
const $1e36063d22283059$var$openModal = (wrapper)=>{
    const modalBg = document.querySelector(".standorte__modal-bg");
    const id = "altheim-modal";
    const modal = document.getElementById(id);
    $1e36063d22283059$var$STOPSLIDERS = true;
    modalBg.style.display = "block";
    (0, $E0sjW.gsap).to(modalBg, {
        duration: 0.25,
        opacity: 1
    });
    modal.style.display = "block";
    (0, $E0sjW.gsap).to(modal, {
        duration: 0.25,
        opacity: 1
    });
    modal.addEventListener("click", (e)=>{
        console.log(e.target);
        if (!e.target.classList.contains("arrow")) $1e36063d22283059$var$closeModal(modal);
    });
    modalBg.addEventListener("click", ()=>{
        $1e36063d22283059$var$closeModal(modal);
    });
    $1e36063d22283059$var$startSlider(modal, false);
};
const $1e36063d22283059$var$closeModal = (modal)=>{
    const modalBg = document.querySelector(".standorte__modal-bg");
    (0, $E0sjW.gsap).to(modal, {
        duration: 0.25,
        opacity: 0,
        onComplete: ()=>{
            modal.style.display = "none";
        }
    });
    (0, $E0sjW.gsap).to(modalBg, {
        duration: 0.25,
        opacity: 0,
        onComplete: ()=>{
            modalBg.style.display = "none";
        }
    });
    $1e36063d22283059$var$STOPSLIDERS = false;
};

})();
//# sourceMappingURL=standorte.cf057e6c.js.map
